import React, { useEffect, useState } from 'react';
import FilterDropdown from '../Filter/components/FilterDropdown';
import { translate } from '../../services/translate';
import { licensePlateRecognitionService } from '../../services/central-api/license-plate-recognition';
import { UseFormReturn } from 'react-hook-form';
import FormDropDownPicker from '../FormDropDownPicker';

type Props = {
    zIndex: number;
} & ({
    form?: undefined;
    fieldName?: undefined;
    value: string;
    setValue: React.Dispatch<React.SetStateAction<string>>;
} | {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    form: UseFormReturn<any, any, any>;
    fieldName: string;
    value?: undefined;
    setValue?: undefined;
});

export default function TypesDropdown({ value, setValue, zIndex, form, fieldName }: Props) {
    const [items, setItems] = useState<{ label: string; value: string; }[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    async function getItems() {
        try {
            setIsLoading(true);
            const items = await licensePlateRecognitionService.getTypes();
            setItems(items.map((item) => {
                return {
                    value: item.type,
                    label: item.type
                };
            }));
        } catch (err) {
            console.error(err);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        getItems();
    }, []);

    if (form && fieldName) {
        return (
            <FormDropDownPicker
                label={translate('carMetadataVehicleType')}
                items={items}
                multiple={false}
                fieldName={fieldName}
                form={form}
                zIndex={zIndex}
                loading={isLoading}
            />
        );
    } else if (value !== undefined && setValue !== undefined) {
        return (
            <FilterDropdown
                label={translate('carMetadataVehicleType')}
                items={items}
                multiple={false}
                setValue={setValue}
                value={value}
                zIndex={zIndex}
                loading={isLoading}
            />
        );
    }
}
